export default __webpack_public_path__ + "c3a2edeffeb6a816e51304d1f73b3d8a.jpeg";